export default __webpack_public_path__ + "static/media/google_logo.cb396f1c.svg";